export default "__VITE_ASSET__DeZK_A4C__"